import { render, staticRenderFns } from "./permissionTreeDialog.vue?vue&type=template&id=f379d8a6&scoped=true&"
import script from "./permissionTreeDialog.vue?vue&type=script&lang=js&"
export * from "./permissionTreeDialog.vue?vue&type=script&lang=js&"
import style0 from "./permissionTreeDialog.vue?vue&type=style&index=0&id=f379d8a6&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f379d8a6",
  null
  
)

export default component.exports